import { researchIntelligenceContent } from '@/config/marketing-content/feature-pages'
import { FeatureMarketingPage } from '@/components/marketing/feature-marketing-page'

export function ResearchIntelligencePage() {
  return <FeatureMarketingPage content={researchIntelligenceContent} />
}
